// extracted by mini-css-extract-plugin
export var checkbox = "_3f-0";
export var circle = "_3f-3";
export var horizontalContainer = "_3f-7";
export var sm = "_3f-5";
export var switch0 = "_3f-2";
export var switchDisabled = "_3f-8";
export var switchEnabled = "_3f-1";
export var textSwitchContainer = "_3f-9";
export var textSwitchOption = "_3f-a";
export var textSwitchOptionSelected = "_3f-b";
export var verticalContainer = "_3f-6";
export var xs = "_3f-4";